const SIGNED_OUT_MARKER_KEY = "signed-out";
const SIGNED_OUT_MARKER_VALUE = "1";

type SignOutNavigator = (url: string) => void;

let navigatorForTest: SignOutNavigator | undefined;
let signOutStarted = false;

/** 現在の URL に IdP からのサインアウト復帰マーカーがあるかを返す。 */
export function hasSignedOutReturnMarker(search?: string): boolean {
  const currentSearch = search ?? (typeof window === "undefined" ? "" : window.location.search);
  return new URLSearchParams(currentSearch).get(SIGNED_OUT_MARKER_KEY) === SIGNED_OUT_MARKER_VALUE;
}

/** URL から復帰マーカーを取り除き、再読込時の再表示を防ぐ。 */
export function clearSignedOutReturnMarker(): void {
  if (typeof window === "undefined") {
    return;
  }
  try {
    window.history.replaceState({}, "", "/");
  } catch {
    // history が使えない環境では、マーカーを残して安全側に倒す。
  }
}

/** MEIDEN CONNECT の RP-Initiated Logout URL を組み立てる。 */
export function buildMeidenConnectSignOutUrl(input: {
  readonly authServiceOrigin: string;
  readonly serviceOrigin: string;
  readonly idToken: string | undefined;
}): string {
  const serviceUrl = new URL(input.serviceOrigin);
  const signOutUrl = new URL("/signout", input.authServiceOrigin);
  signOutUrl.searchParams.set("client_id", serviceUrl.host);
  if (input.idToken !== undefined && input.idToken.length > 0) {
    signOutUrl.searchParams.set("id_token_hint", input.idToken);
  }
  signOutUrl.searchParams.set(
    "post_logout_redirect_uri",
    new URL("/?signed-out=1", serviceUrl).href
  );
  return signOutUrl.href;
}

/** サインアウト URL へトップレベル遷移する。 */
export function navigateToSignOut(url: string): void {
  if (navigatorForTest !== undefined) {
    navigatorForTest(url);
    return;
  }
  window.location.assign(url);
}

/** テスト用に遷移処理を差し替える。引数を省略すると既定実装へ戻る。 */
export function setSignOutNavigatorForTest(navigate?: SignOutNavigator): void {
  navigatorForTest = navigate;
}

/** 同一ドキュメント内でサインアウト実行を 1 回に限定する。 */
export function tryBeginSignOut(): boolean {
  if (signOutStarted) {
    return false;
  }
  signOutStarted = true;
  return true;
}

/** 遷移開始前に失敗した試行を終了し、利用者による再試行を許可する。 */
export function releaseSignOutAttempt(): void {
  signOutStarted = false;
}

/** テスト用にサインアウト多重実行ガードを初期状態へ戻す。 */
export function resetSignOutGuardForTest(): void {
  releaseSignOutAttempt();
}
